export const LaughingEmoji = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.0001 29.5315C2.01577 29.5315 0.451086 18.2815 0.468899 15.469V14.5315C0.451086 11.719 2.01577 0.468994 15.0001 0.468994C27.9845 0.468994 29.5492 11.719 29.5314 14.5315V15.469C29.5492 18.2815 27.9845 29.5315 15.0001 29.5315Z"
        fill="url(#paint0_linear_137_429)"
      />
      <path
        d="M15.0001 29.5315C2.01577 29.5315 0.451086 18.2815 0.468899 15.469V14.5315C0.451086 11.719 2.01577 0.468994 15.0001 0.468994C27.9845 0.468994 29.5492 11.719 29.5314 14.5315V15.469C29.5492 18.2815 27.9845 29.5315 15.0001 29.5315Z"
        fill="url(#paint1_linear_137_429)"
      />
      <path
        d="M24.8447 12.6565C24.8447 11.5376 24.4003 10.4646 23.6091 9.67339C22.8179 8.88222 21.7449 8.43774 20.626 8.43774C19.5071 8.43774 18.434 8.88222 17.6429 9.67339C16.8517 10.4646 16.4072 11.5376 16.4072 12.6565C16.4072 12.7357 16.4147 12.8126 16.4189 12.8909C16.4147 12.9691 16.4072 13.046 16.4072 13.1252C16.4072 14.2441 16.8517 15.3172 17.6429 16.1083C18.434 16.8995 19.5071 17.344 20.626 17.344C21.7449 17.344 22.8179 16.8995 23.6091 16.1083C24.4003 15.3172 24.8447 14.2441 24.8447 13.1252C24.8447 13.046 24.8372 12.9691 24.833 12.8909C24.8372 12.8126 24.8447 12.7357 24.8447 12.6565Z"
        fill="#FAA15D"
      />
      <path
        d="M9.375 8.43774C8.25612 8.43774 7.18306 8.88222 6.39189 9.67339C5.60072 10.4646 5.15625 11.5376 5.15625 12.6565C5.15625 12.7357 5.16375 12.8126 5.16797 12.8909C5.16375 12.9691 5.15625 13.046 5.15625 13.1252C5.15625 14.2441 5.60072 15.3172 6.39189 16.1083C7.18306 16.8995 8.25612 17.344 9.375 17.344C10.4939 17.344 11.5669 16.8995 12.3581 16.1083C13.1493 15.3172 13.5938 14.2441 13.5938 13.1252C13.5938 13.046 13.5863 12.9691 13.582 12.8909C13.5863 12.8126 13.5938 12.7357 13.5938 12.6565C13.5938 11.5376 13.1493 10.4646 12.3581 9.67339C11.5669 8.88222 10.4939 8.43774 9.375 8.43774Z"
        fill="#FAA44E"
      />
      <path
        d="M24.8438 12.1877C24.8438 11.0689 24.3993 9.99581 23.6081 9.20464C22.8169 8.41347 21.7439 7.96899 20.625 7.96899C19.5061 7.96899 18.4331 8.41347 17.6419 9.20464C16.8507 9.99581 16.4062 11.0689 16.4062 12.1877C16.4062 12.267 16.4138 12.3438 16.418 12.4221C16.4138 12.5004 16.4062 12.5773 16.4062 12.6565C16.4062 13.7754 16.8507 14.8484 17.6419 15.6396C18.4331 16.4308 19.5061 16.8752 20.625 16.8752C21.7439 16.8752 22.8169 16.4308 23.6081 15.6396C24.3993 14.8484 24.8438 13.7754 24.8438 12.6565C24.8438 12.5773 24.8362 12.5004 24.832 12.4221C24.8362 12.3438 24.8438 12.267 24.8438 12.1877ZM9.375 7.96899C8.25612 7.96899 7.18306 8.41347 6.39189 9.20464C5.60072 9.99581 5.15625 11.0689 5.15625 12.1877C5.15625 12.267 5.16375 12.3438 5.16797 12.4221C5.16375 12.5004 5.15625 12.5773 5.15625 12.6565C5.15625 13.7754 5.60072 14.8484 6.39189 15.6396C7.18306 16.4308 8.25612 16.8752 9.375 16.8752C10.4939 16.8752 11.5669 16.4308 12.3581 15.6396C13.1493 14.8484 13.5938 13.7754 13.5938 12.6565C13.5938 12.5773 13.5863 12.5004 13.582 12.4221C13.5863 12.3438 13.5938 12.267 13.5938 12.1877C13.5938 11.0689 13.1493 9.99581 12.3581 9.20464C11.5669 8.41347 10.4939 7.96899 9.375 7.96899Z"
        fill="#ED8D06"
      />
      <path
        d="M20.626 16.8752C22.9559 16.8752 24.8447 14.9864 24.8447 12.6565C24.8447 10.3265 22.9559 8.43774 20.626 8.43774C18.296 8.43774 16.4072 10.3265 16.4072 12.6565C16.4072 14.9864 18.296 16.8752 20.626 16.8752Z"
        fill="url(#paint2_radial_137_429)"
      />
      <path
        d="M20.625 15.0001C21.9194 15.0001 22.9688 13.9508 22.9688 12.6564C22.9688 11.362 21.9194 10.3126 20.625 10.3126C19.3306 10.3126 18.2812 11.362 18.2812 12.6564C18.2812 13.9508 19.3306 15.0001 20.625 15.0001Z"
        fill="url(#paint3_radial_137_429)"
      />
      <path
        d="M9.375 16.8752C11.705 16.8752 13.5938 14.9864 13.5938 12.6565C13.5938 10.3265 11.705 8.43774 9.375 8.43774C7.04505 8.43774 5.15625 10.3265 5.15625 12.6565C5.15625 14.9864 7.04505 16.8752 9.375 16.8752Z"
        fill="url(#paint4_radial_137_429)"
      />
      <path
        d="M9.37549 15.0001C10.6699 15.0001 11.7192 13.9508 11.7192 12.6564C11.7192 11.362 10.6699 10.3126 9.37549 10.3126C8.08107 10.3126 7.03174 11.362 7.03174 12.6564C7.03174 13.9508 8.08107 15.0001 9.37549 15.0001Z"
        fill="url(#paint5_radial_137_429)"
      />
      <path
        d="M22.88 18.9387C22.9528 18.9225 23.0286 18.9242 23.1006 18.9437C23.1727 18.9631 23.239 18.9998 23.2938 19.0505C23.3486 19.1011 23.3904 19.1643 23.4155 19.2347C23.4405 19.305 23.4482 19.3803 23.4378 19.4543C23.4039 19.8437 23.3364 20.2295 23.2362 20.6074C20.7222 22.0112 17.8811 22.7238 15.0021 22.6727C12.1231 22.7234 9.28198 22.0103 6.76809 20.606C6.66786 20.2281 6.60042 19.8423 6.56652 19.4529C6.55612 19.3789 6.56378 19.3036 6.58885 19.2333C6.61391 19.1629 6.65565 19.0997 6.71047 19.0491C6.76529 18.9984 6.83158 18.9617 6.90365 18.9423C6.97573 18.9228 7.05145 18.9211 7.12434 18.9372C9.6891 19.6566 12.3385 20.03 15.0021 20.0477C17.6658 20.0305 20.3151 19.6575 22.88 18.9387Z"
        fill="url(#paint6_linear_137_429)"
      />
      <path
        d="M23.4395 18.9227H23.4357C23.4372 18.8536 23.4228 18.785 23.3938 18.7223C23.3648 18.6596 23.3219 18.6042 23.2683 18.5606C23.2147 18.5169 23.1518 18.4861 23.0845 18.4704C23.0172 18.4546 22.9472 18.4545 22.8798 18.4699C20.3149 19.1888 17.6656 19.5617 15.002 19.5789C12.3383 19.5613 9.68891 19.1878 7.12414 18.4685C7.05663 18.453 6.98649 18.4532 6.91906 18.469C6.85163 18.4848 6.7887 18.5158 6.73508 18.5596C6.68145 18.6034 6.63854 18.6589 6.60962 18.7218C6.5807 18.7848 6.56653 18.8535 6.5682 18.9227H6.56445V19.3914H6.5682C6.56679 19.4122 6.56679 19.433 6.5682 19.4538C6.6021 19.8432 6.66954 20.2291 6.76977 20.6069C6.83077 20.8551 6.90749 21.0992 6.99945 21.3377C7.49111 22.5849 8.31637 23.6729 9.38492 24.4825C10.9824 25.7525 12.963 26.4438 15.0038 26.4438C17.0446 26.4438 19.0252 25.7525 20.6227 24.4825C21.6913 23.6729 22.5165 22.5849 23.0082 21.3377C23.1002 21.0992 23.1769 20.8551 23.2379 20.6069C23.3381 20.2291 23.4056 19.8432 23.4395 19.4538C23.4409 19.433 23.4409 19.4122 23.4395 19.3914V18.9227Z"
        fill="#ED8D06"
      />
      <path
        d="M23.4357 19.3916C23.4372 19.3225 23.4228 19.2539 23.3938 19.1912C23.3648 19.1284 23.3219 19.0731 23.2683 19.0295C23.2147 18.9858 23.1518 18.9549 23.0845 18.9392C23.0172 18.9235 22.9472 18.9233 22.8798 18.9388C20.3149 19.6576 17.6656 20.0306 15.002 20.0478C12.3383 20.0302 9.68891 19.6567 7.12414 18.9373C7.05663 18.9219 6.98649 18.9221 6.91906 18.9379C6.85163 18.9537 6.7887 18.9847 6.73508 19.0285C6.68145 19.0723 6.63854 19.1278 6.60962 19.1907C6.5807 19.2536 6.56653 19.3223 6.5682 19.3916H6.56445V19.8603H6.5682C6.56679 19.8811 6.56679 19.9019 6.5682 19.9227C6.6021 20.3121 6.66954 20.6979 6.76977 21.0758C6.83077 21.324 6.90749 21.5681 6.99945 21.8066C7.49111 23.0538 8.31637 24.1418 9.38492 24.9514C10.9824 26.2214 12.963 26.9127 15.0038 26.9127C17.0446 26.9127 19.0252 26.2214 20.6227 24.9514C21.6913 24.1418 22.5165 23.0538 23.0082 21.8066C23.1002 21.5681 23.1769 21.324 23.2379 21.0758C23.3381 20.6979 23.4056 20.3121 23.4395 19.9227C23.4409 19.9019 23.4409 19.8811 23.4395 19.8603V19.3916H23.4357Z"
        fill="#F9BF06"
      />
      <path
        d="M18.2449 25.8415C16.1525 26.6165 13.8517 26.6165 11.7593 25.8415C11.9135 25.4337 12.6115 24.079 15.0021 24.079C17.3927 24.079 18.0907 25.4337 18.2449 25.8415Z"
        fill="#8F030E"
      />
      <path
        d="M23.0065 21.3378C22.5148 22.585 21.6896 23.673 20.621 24.4826C19.9035 25.0551 19.1021 25.5136 18.2449 25.842C18.0907 25.4337 17.3928 24.079 15.0021 24.079C12.6115 24.079 11.9135 25.4333 11.7593 25.8411C10.9022 25.5127 10.1008 25.0542 9.38322 24.4817C8.31467 23.6721 7.48941 22.5841 6.99775 21.3369C6.90572 21.0984 6.829 20.8543 6.76807 20.6061C9.28196 22.0103 12.1231 22.7234 15.0021 22.6728C17.8812 22.7234 20.7223 22.0103 23.2362 20.6061C23.1753 20.8546 23.0986 21.099 23.0065 21.3378Z"
        fill="url(#paint7_linear_137_429)"
      />
      <path
        d="M22.88 18.9387C22.9528 18.9225 23.0286 18.9242 23.1006 18.9437C23.1727 18.9631 23.239 18.9998 23.2938 19.0505C23.3486 19.1011 23.3904 19.1643 23.4155 19.2347C23.4405 19.305 23.4482 19.3803 23.4378 19.4543C23.4039 19.8437 23.3364 20.2295 23.2362 20.6074C20.7222 22.0112 17.8811 22.7238 15.0021 22.6727C12.1231 22.7234 9.28198 22.0103 6.76809 20.606C6.66786 20.2281 6.60042 19.8423 6.56652 19.4529C6.55612 19.3789 6.56378 19.3036 6.58885 19.2333C6.61391 19.1629 6.65565 19.0997 6.71047 19.0491C6.76529 18.9984 6.83158 18.9617 6.90365 18.9423C6.97573 18.9228 7.05145 18.9211 7.12434 18.9372C9.6891 19.6566 12.3385 20.03 15.0021 20.0477C17.6658 20.0305 20.3151 19.6575 22.88 18.9387Z"
        fill="url(#paint8_linear_137_429)"
      />
      <path
        d="M22.88 18.9387C22.9528 18.9225 23.0286 18.9242 23.1006 18.9437C23.1727 18.9631 23.239 18.9998 23.2938 19.0505C23.3486 19.1011 23.3904 19.1643 23.4155 19.2347C23.4405 19.305 23.4482 19.3803 23.4378 19.4543C23.4039 19.8437 23.3364 20.2295 23.2362 20.6074C20.7222 22.0112 17.8811 22.7238 15.0021 22.6727C12.1231 22.7234 9.28198 22.0103 6.76809 20.606C6.66786 20.2281 6.60042 19.8423 6.56652 19.4529C6.55612 19.3789 6.56378 19.3036 6.58885 19.2333C6.61391 19.1629 6.65565 19.0997 6.71047 19.0491C6.76529 18.9984 6.83158 18.9617 6.90365 18.9423C6.97573 18.9228 7.05145 18.9211 7.12434 18.9372C9.6891 19.6566 12.3385 20.03 15.0021 20.0477C17.6658 20.0305 20.3151 19.6575 22.88 18.9387Z"
        fill="url(#paint9_linear_137_429)"
      />
      <path
        d="M23.9063 6.16364C23.9055 6.04094 23.857 5.92338 23.7709 5.83588C23.6849 5.74838 23.5682 5.69781 23.4456 5.69489C19.9937 5.57582 18.489 4.13207 17.9776 3.47067C17.9121 3.38232 17.8176 3.31982 17.7106 3.29411C17.6037 3.2684 17.4911 3.28112 17.3926 3.33004C17.3358 3.3588 17.2857 3.39901 17.2452 3.44812C17.2048 3.49722 17.1749 3.55418 17.1576 3.61539C17.1402 3.6766 17.1357 3.74073 17.1444 3.80376C17.1531 3.86679 17.1747 3.92734 17.2079 3.9816C17.1586 4.06011 17.1344 4.15179 17.1385 4.24441C17.1426 4.33703 17.1748 4.4262 17.2309 4.50004C17.8721 5.32739 19.6177 6.97129 23.4291 7.09879C23.4914 7.09991 23.5533 7.08862 23.6111 7.06556C23.669 7.04251 23.7216 7.00816 23.7661 6.96452C23.8105 6.92088 23.8458 6.86882 23.8699 6.81139C23.8939 6.75397 23.9063 6.69231 23.9063 6.63004C23.9045 6.54674 23.8795 6.46559 23.8341 6.39567C23.8786 6.32618 23.9035 6.24605 23.9063 6.16364ZM12.6095 3.33239C12.5109 3.28347 12.3984 3.27075 12.2914 3.29646C12.1845 3.32216 12.09 3.38466 12.0245 3.47301C11.513 4.13442 10.0088 5.57817 6.55648 5.69723C6.43382 5.70015 6.31711 5.75072 6.2311 5.83822C6.14508 5.92573 6.09652 6.04328 6.0957 6.16598C6.09813 6.24919 6.12308 6.33019 6.16789 6.40035C6.12257 6.47028 6.09758 6.55142 6.0957 6.63473C6.09569 6.697 6.10809 6.75865 6.13217 6.81608C6.15626 6.87351 6.19154 6.92556 6.23597 6.9692C6.28039 7.01284 6.33307 7.04719 6.39092 7.07025C6.44876 7.0933 6.51063 7.1046 6.57289 7.10348C10.3843 6.97598 12.1299 5.33207 12.7712 4.50473C12.8272 4.43089 12.8595 4.34172 12.8636 4.2491C12.8677 4.15647 12.8435 4.0648 12.7941 3.98629C12.8278 3.93194 12.8497 3.8712 12.8586 3.80792C12.8674 3.74463 12.863 3.6802 12.8457 3.6187C12.8283 3.55721 12.7983 3.5 12.7577 3.45071C12.717 3.40142 12.6665 3.36112 12.6095 3.33239Z"
        fill="#F99C06"
      />
      <path
        d="M23.9064 6.16378C23.9064 6.22609 23.894 6.28778 23.8699 6.34524C23.8458 6.4027 23.8105 6.45478 23.766 6.49842C23.7215 6.54207 23.6688 6.57641 23.6109 6.59944C23.553 6.62246 23.4911 6.63371 23.4288 6.63253C19.6178 6.50503 17.8722 4.86112 17.231 4.03378C17.1891 3.97903 17.1599 3.91574 17.1454 3.84841C17.1308 3.78108 17.1313 3.71137 17.1467 3.64424C17.1621 3.5771 17.1922 3.5142 17.2347 3.46C17.2772 3.4058 17.3311 3.36164 17.3927 3.33065C17.4912 3.28173 17.6038 3.26901 17.7107 3.29472C17.8177 3.32043 17.9122 3.38293 17.9777 3.47128C18.4891 4.13268 19.9933 5.57643 23.4456 5.6955C23.5683 5.69842 23.685 5.74899 23.771 5.83649C23.857 5.92399 23.9056 6.04155 23.9064 6.16425V6.16378Z"
        fill="url(#paint10_radial_137_429)"
      />
      <path
        d="M6.09375 6.16364C6.09457 6.04094 6.14313 5.92338 6.22915 5.83588C6.31516 5.74838 6.43187 5.69781 6.55453 5.69489C10.0064 5.57582 11.5111 4.13207 12.0225 3.47067C12.088 3.38232 12.1825 3.31982 12.2895 3.29411C12.3964 3.2684 12.509 3.28112 12.6075 3.33004C12.669 3.36103 12.723 3.40519 12.7655 3.45939C12.808 3.51359 12.838 3.57649 12.8535 3.64363C12.8689 3.71076 12.8694 3.78047 12.8548 3.8478C12.8402 3.91513 12.811 3.97842 12.7692 4.03317C12.128 4.86051 10.3823 6.50442 6.57141 6.63192C6.50914 6.6331 6.44727 6.62187 6.3894 6.59887C6.33152 6.57587 6.27881 6.54157 6.23434 6.49798C6.18988 6.45438 6.15454 6.40236 6.1304 6.34496C6.10626 6.28755 6.0938 6.22591 6.09375 6.16364Z"
        fill="url(#paint11_radial_137_429)"
      />
      <path
        d="M0.606445 17.3438H29.3965"
        stroke="#00FFA3"
        strokeWidth="0.821807"
        strokeLinecap="round"
      />
      <path
        d="M0.470215 17.3438H29.439L28.8952 19.6034L28.2785 21.3437L1.77436 21.4828C1.77436 21.4828 1.35417 20.3999 1.12921 19.6862C0.843527 18.7799 0.470215 17.3438 0.470215 17.3438Z"
        fill="url(#paint12_linear_137_429)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_137_429"
          x1="15.0001"
          y1="29.2793"
          x2="15.0001"
          y2="5.36884"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE100" />
          <stop offset="0.217" stopColor="#F98900" />
          <stop offset="0.465" stopColor="#ECA483" />
          <stop offset="0.697" stopColor="#83BEEC" />
          <stop offset="0.995" stopColor="#2A97EC" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_137_429"
          x1="15.0001"
          y1="0.611494"
          x2="15.0001"
          y2="29.674"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE100" />
          <stop offset="1" stopColor="#F98900" />
        </linearGradient>
        <radialGradient
          id="paint2_radial_137_429"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(20.626 12.6565) scale(4.21875)"
        >
          <stop stopColor="white" />
          <stop offset="0.505" stopColor="white" />
          <stop offset="0.588" stopColor="white" />
          <stop offset="0.804" stopColor="#FDFEFF" />
          <stop offset="0.886" stopColor="#F6FAFF" />
          <stop offset="0.945" stopColor="#EAF3FF" />
          <stop offset="0.993" stopColor="#D9EAFF" />
          <stop offset="1" stopColor="#D6E8FF" />
        </radialGradient>
        <radialGradient
          id="paint3_radial_137_429"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(20.625 12.6564) scale(2.34375)"
        >
          <stop offset="0.005" stopColor="#414D4D" />
          <stop offset="0.206" stopColor="#3A4545" />
          <stop offset="0.522" stopColor="#272E2E" />
          <stop offset="0.914" stopColor="#080909" />
          <stop offset="1" />
        </radialGradient>
        <radialGradient
          id="paint4_radial_137_429"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(9.375 12.6565) scale(4.21875)"
        >
          <stop stopColor="white" />
          <stop offset="0.505" stopColor="white" />
          <stop offset="0.588" stopColor="white" />
          <stop offset="0.804" stopColor="#FDFEFF" />
          <stop offset="0.886" stopColor="#F6FAFF" />
          <stop offset="0.945" stopColor="#EAF3FF" />
          <stop offset="0.993" stopColor="#D9EAFF" />
          <stop offset="1" stopColor="#D6E8FF" />
        </radialGradient>
        <radialGradient
          id="paint5_radial_137_429"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(9.37549 12.6564) scale(2.34375)"
        >
          <stop offset="0.005" stopColor="#414D4D" />
          <stop offset="0.206" stopColor="#3A4545" />
          <stop offset="0.522" stopColor="#272E2E" />
          <stop offset="0.914" stopColor="#080909" />
          <stop offset="1" />
        </radialGradient>
        <linearGradient
          id="paint6_linear_137_429"
          x1="6.56465"
          y1="20.7982"
          x2="23.4396"
          y2="20.7982"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B8B4B2" />
          <stop offset="0.143" stopColor="#D0CCC9" />
          <stop offset="0.374" stopColor="#F2EDEA" />
          <stop offset="0.5" stopColor="#FFFAF6" />
          <stop offset="0.638" stopColor="#F9F5F1" />
          <stop offset="0.825" stopColor="#E8E5E3" />
          <stop offset="1" stopColor="#D1D1D1" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_137_429"
          x1="15.0021"
          y1="26.5517"
          x2="15.0021"
          y2="18.942"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#69101B" />
          <stop offset="0.427" stopColor="#400A10" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_137_429"
          x1="6.56465"
          y1="20.7982"
          x2="23.4396"
          y2="20.7982"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B8B4B2" />
          <stop offset="0.143" stopColor="#D0CCC9" />
          <stop offset="0.374" stopColor="#F2EDEA" />
          <stop offset="0.5" stopColor="#FFFAF6" />
          <stop offset="0.638" stopColor="#F9F5F1" />
          <stop offset="0.825" stopColor="#E8E5E3" />
          <stop offset="1" stopColor="#D1D1D1" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_137_429"
          x1="15.0021"
          y1="19.4679"
          x2="15.0021"
          y2="22.6188"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ABABAB" stopOpacity="0.5" />
          <stop offset="0.541" stopColor="#C1C1C1" stopOpacity="0.216" />
          <stop offset="1" stopColor="#D1D1D1" stopOpacity="0" />
        </linearGradient>
        <radialGradient
          id="paint10_radial_137_429"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(20.5202 4.95815) scale(2.67141)"
        >
          <stop offset="0.005" stopColor="#414D4D" />
          <stop offset="0.206" stopColor="#3A4545" />
          <stop offset="0.522" stopColor="#272E2E" />
          <stop offset="0.914" stopColor="#080909" />
          <stop offset="1" />
        </radialGradient>
        <radialGradient
          id="paint11_radial_137_429"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(20.52 4.95801) scale(2.67141)"
        >
          <stop offset="0.005" stopColor="#414D4D" />
          <stop offset="0.206" stopColor="#3A4545" />
          <stop offset="0.522" stopColor="#272E2E" />
          <stop offset="0.914" stopColor="#080909" />
          <stop offset="1" />
        </radialGradient>
        <linearGradient
          id="paint12_linear_137_429"
          x1="15.0015"
          y1="17.3437"
          x2="15.0015"
          y2="21.3437"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFA3" />
          <stop offset="1" stopColor="#00FFA3" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export const ExcitedEmoji = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_137_507)">
        <path
          d="M15.0001 29.5312C2.01577 29.5312 0.451086 18.2812 0.468899 15.4688V14.5312C0.451086 11.7188 2.01577 0.46875 15.0001 0.46875C27.9845 0.46875 29.5492 11.7188 29.5314 14.5312V15.4688C29.5492 18.2812 27.9845 29.5312 15.0001 29.5312Z"
          fill="url(#paint0_linear_137_507)"
        />
        <path
          d="M22.9688 19.6875C22.9688 18.9416 22.6724 18.2262 22.145 17.6988C21.6175 17.1713 20.9022 16.875 20.1562 16.875H9.84375C9.09783 16.875 8.38246 17.1713 7.85501 17.6988C7.32757 18.2262 7.03125 18.9416 7.03125 19.6875C7.03125 19.7667 7.03687 19.8445 7.04297 19.9219C7.03598 19.9998 7.03207 20.078 7.03125 20.1562C7.03125 20.9022 7.32757 21.6175 7.85501 22.145C8.38246 22.6724 9.09783 22.9688 9.84375 22.9688H20.1562C20.9022 22.9688 21.6175 22.6724 22.145 22.145C22.6724 21.6175 22.9688 20.9022 22.9688 20.1562C22.9679 20.078 22.964 19.9998 22.957 19.9219C22.964 19.8439 22.9679 19.7657 22.9688 19.6875Z"
          fill="#F9BF06"
        />
        <path
          d="M22.9688 19.2188C22.9688 18.4728 22.6724 17.7575 22.145 17.23C21.6175 16.7026 20.9022 16.4063 20.1562 16.4062H9.84375C9.09783 16.4063 8.38246 16.7026 7.85501 17.23C7.32757 17.7575 7.03125 18.4728 7.03125 19.2188C7.03125 19.298 7.03687 19.3758 7.04297 19.4531C7.03598 19.5311 7.03207 19.6093 7.03125 19.6875C7.03125 20.4334 7.32757 21.1488 7.85501 21.6762C8.38246 22.2037 9.09783 22.5 9.84375 22.5H20.1562C20.9022 22.5 21.6175 22.2037 22.145 21.6762C22.6724 21.1488 22.9688 20.4334 22.9688 19.6875C22.9679 19.6093 22.964 19.5311 22.957 19.4531C22.964 19.3752 22.9679 19.297 22.9688 19.2188Z"
          fill="#ED8D06"
        />
        <path
          d="M9.84375 22.5H20.1562C20.9022 22.5 21.6175 22.2037 22.145 21.6762C22.6724 21.1488 22.9688 20.4334 22.9688 19.6875H7.03125C7.03125 20.4334 7.32757 21.1488 7.85501 21.6762C8.38246 22.2037 9.09783 22.5 9.84375 22.5Z"
          fill="url(#paint1_linear_137_507)"
        />
        <path
          d="M20.1562 16.875H9.84375C9.09783 16.875 8.38246 17.1713 7.85501 17.6988C7.32757 18.2262 7.03125 18.9416 7.03125 19.6875H22.9688C22.9688 18.9416 22.6724 18.2262 22.145 17.6988C21.6175 17.1713 20.9022 16.875 20.1562 16.875Z"
          fill="url(#paint2_linear_137_507)"
        />
        <path
          d="M20.1562 16.875H9.84375C9.09783 16.875 8.38246 17.1713 7.85501 17.6988C7.32757 18.2262 7.03125 18.9416 7.03125 19.6875C7.03125 20.4334 7.32757 21.1488 7.85501 21.6762C8.38246 22.2037 9.09783 22.5 9.84375 22.5H20.1562C20.9022 22.5 21.6175 22.2037 22.145 21.6762C22.6724 21.1488 22.9688 20.4334 22.9688 19.6875C22.9688 18.9416 22.6724 18.2262 22.145 17.6988C21.6175 17.1713 20.9022 16.875 20.1562 16.875Z"
          fill="url(#paint3_linear_137_507)"
        />
        <path
          d="M20.1562 16.875H9.84375C9.09783 16.875 8.38246 17.1713 7.85501 17.6988C7.32757 18.2262 7.03125 18.9416 7.03125 19.6875H22.9688C22.9688 18.9416 22.6724 18.2262 22.145 17.6988C21.6175 17.1713 20.9022 16.875 20.1562 16.875Z"
          fill="url(#paint4_linear_137_507)"
        />
        <path
          d="M21.71 17.3438H21.7034C21.2453 17.0384 20.7071 16.8753 20.1565 16.875H9.84402C9.29346 16.8753 8.75529 17.0384 8.29715 17.3438H8.29152C7.78819 17.6776 7.40571 18.1647 7.20068 18.7328C6.99566 19.301 6.97898 19.92 7.15312 20.4984C7.32725 21.0767 7.68295 21.5837 8.16758 21.9441C8.65221 22.3046 9.24002 22.4995 9.84402 22.5H10.3128C9.60776 22.4995 8.92864 22.2343 8.40993 21.7568C7.89121 21.2793 7.57074 20.6244 7.51199 19.9219H22.4886C22.4298 20.6244 22.1093 21.2793 21.5906 21.7568C21.0719 22.2343 20.3928 22.4995 19.6878 22.5H20.1565C20.7606 22.4997 21.3486 22.305 21.8333 21.9446C22.3181 21.5841 22.674 21.0772 22.8482 20.4988C23.0225 19.9204 23.0059 19.3013 22.8009 18.733C22.5959 18.1648 22.2134 17.6777 21.71 17.3438ZM7.50027 19.6875C7.50027 18.3933 8.68527 17.3438 10.1473 17.3438H19.8532C21.3153 17.3438 22.5003 18.3933 22.5003 19.6875H7.50027Z"
          fill="url(#paint5_linear_137_507)"
        />
        <path
          d="M24.8438 10.3125C24.8438 9.19362 24.3993 8.12056 23.6081 7.32939C22.8169 6.53822 21.7439 6.09375 20.625 6.09375C19.5061 6.09375 18.4331 6.53822 17.6419 7.32939C16.8507 8.12056 16.4063 9.19362 16.4062 10.3125C16.4062 10.3917 16.4138 10.4686 16.418 10.5469C16.4138 10.6252 16.4062 10.702 16.4062 10.7812C16.4063 11.9001 16.8507 12.9732 17.6419 13.7644C18.4331 14.5555 19.5061 15 20.625 15C21.7439 15 22.8169 14.5555 23.6081 13.7644C24.3993 12.9732 24.8438 11.9001 24.8438 10.7812C24.8438 10.702 24.8362 10.6252 24.832 10.5469C24.8362 10.4686 24.8438 10.3917 24.8438 10.3125Z"
          fill="#FAA15D"
        />
        <path
          d="M9.375 6.09375C8.25612 6.09375 7.18306 6.53822 6.39189 7.32939C5.60072 8.12056 5.15625 9.19362 5.15625 10.3125C5.15625 10.3917 5.16375 10.4686 5.16797 10.5469C5.16375 10.6252 5.15625 10.702 5.15625 10.7812C5.15625 11.9001 5.60072 12.9732 6.39189 13.7644C7.18306 14.5555 8.25612 15 9.375 15C10.4939 15 11.5669 14.5555 12.3581 13.7644C13.1493 12.9732 13.5938 11.9001 13.5938 10.7812C13.5938 10.702 13.5863 10.6252 13.582 10.5469C13.5863 10.4686 13.5938 10.3917 13.5938 10.3125C13.5938 9.19362 13.1493 8.12056 12.3581 7.32939C11.5669 6.53822 10.4939 6.09375 9.375 6.09375Z"
          fill="#FAA44E"
        />
        <path
          d="M24.8438 9.84375C24.8438 8.72487 24.3993 7.65181 23.6081 6.86064C22.8169 6.06947 21.7439 5.625 20.625 5.625C19.5061 5.625 18.4331 6.06947 17.6419 6.86064C16.8507 7.65181 16.4062 8.72487 16.4062 9.84375C16.4062 9.92297 16.4138 9.99984 16.418 10.0781C16.4138 10.1564 16.4062 10.2333 16.4062 10.3125C16.4062 11.4314 16.8507 12.5044 17.6419 13.2956C18.4331 14.0868 19.5061 14.5312 20.625 14.5312C21.7439 14.5312 22.8169 14.0868 23.6081 13.2956C24.3993 12.5044 24.8438 11.4314 24.8438 10.3125C24.8438 10.2333 24.8362 10.1564 24.832 10.0781C24.8362 9.99984 24.8438 9.92297 24.8438 9.84375ZM9.375 5.625C8.25612 5.625 7.18306 6.06947 6.39189 6.86064C5.60072 7.65181 5.15625 8.72487 5.15625 9.84375C5.15625 9.92297 5.16375 9.99984 5.16797 10.0781C5.16375 10.1564 5.15625 10.2333 5.15625 10.3125C5.15625 11.4314 5.60072 12.5044 6.39189 13.2956C7.18306 14.0868 8.25612 14.5312 9.375 14.5312C10.4939 14.5312 11.5669 14.0868 12.3581 13.2956C13.1493 12.5044 13.5938 11.4314 13.5938 10.3125C13.5938 10.2333 13.5863 10.1564 13.582 10.0781C13.5863 9.99984 13.5938 9.92297 13.5938 9.84375C13.5938 8.72487 13.1493 7.65181 12.3581 6.86064C11.5669 6.06947 10.4939 5.625 9.375 5.625Z"
          fill="#ED8D06"
        />
        <path
          d="M20.625 14.5312C22.955 14.5312 24.8438 12.6425 24.8438 10.3125C24.8438 7.98255 22.955 6.09375 20.625 6.09375C18.295 6.09375 16.4062 7.98255 16.4062 10.3125C16.4062 12.6425 18.295 14.5312 20.625 14.5312Z"
          fill="url(#paint6_radial_137_507)"
        />
        <path
          d="M22.6924 12.3844C23.7926 12.3844 24.6846 11.4925 24.6846 10.3922C24.6846 9.29196 23.7926 8.40002 22.6924 8.40002C21.5921 8.40002 20.7002 9.29196 20.7002 10.3922C20.7002 11.4925 21.5921 12.3844 22.6924 12.3844Z"
          fill="url(#paint7_radial_137_507)"
        />
        <path
          d="M9.375 14.5312C11.705 14.5312 13.5938 12.6425 13.5938 10.3125C13.5938 7.98255 11.705 6.09375 9.375 6.09375C7.04505 6.09375 5.15625 7.98255 5.15625 10.3125C5.15625 12.6425 7.04505 14.5312 9.375 14.5312Z"
          fill="url(#paint8_radial_137_507)"
        />
        <path
          d="M7.39209 12.3844C8.49234 12.3844 9.38428 11.4925 9.38428 10.3922C9.38428 9.29196 8.49234 8.40002 7.39209 8.40002C6.29184 8.40002 5.3999 9.29196 5.3999 10.3922C5.3999 11.4925 6.29184 12.3844 7.39209 12.3844Z"
          fill="url(#paint9_radial_137_507)"
        />
      </g>
      <path d="M15 0.5L15 29.5" stroke="#00FFA3" strokeLinecap="round" />
      <path
        d="M15 0.500013L15 29.5C15 29.5 13.6253 29.6486 11 29.1237L11 0.873911C13.7166 0.339999 15 0.500013 15 0.500013Z"
        fill="url(#paint10_linear_137_507)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_137_507"
          x1="15.0001"
          y1="0.61125"
          x2="15.0001"
          y2="29.6737"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE100" />
          <stop offset="1" stopColor="#F98900" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_137_507"
          x1="7.03125"
          y1="21.0937"
          x2="22.9688"
          y2="21.0937"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B8B4B2" />
          <stop offset="0.143" stopColor="#D0CCC9" />
          <stop offset="0.374" stopColor="#F2EDEA" />
          <stop offset="0.5" stopColor="#FFFAF6" />
          <stop offset="0.638" stopColor="#F9F5F1" />
          <stop offset="0.825" stopColor="#E8E5E3" />
          <stop offset="1" stopColor="#D1D1D1" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_137_507"
          x1="7.03125"
          y1="21.0937"
          x2="22.9688"
          y2="21.0937"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B8B4B2" />
          <stop offset="0.143" stopColor="#D0CCC9" />
          <stop offset="0.374" stopColor="#F2EDEA" />
          <stop offset="0.5" stopColor="#FFFAF6" />
          <stop offset="0.638" stopColor="#F9F5F1" />
          <stop offset="0.825" stopColor="#E8E5E3" />
          <stop offset="1" stopColor="#D1D1D1" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_137_507"
          x1="15"
          y1="22.4766"
          x2="15"
          y2="16.8862"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D1D1D1" stopOpacity="0" />
          <stop offset="0.05" stopColor="#CECECE" stopOpacity="0.041" />
          <stop offset="0.322" stopColor="#C1C1C1" stopOpacity="0.24" />
          <stop offset="0.579" stopColor="#B8B8B8" stopOpacity="0.383" />
          <stop offset="0.812" stopColor="#B2B2B2" stopOpacity="0.47" />
          <stop offset="1" stopColor="#B0B0B0" stopOpacity="0.5" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_137_507"
          x1="15"
          y1="17.168"
          x2="15"
          y2="19.912"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ABABAB" stopOpacity="0.5" />
          <stop offset="0.541" stopColor="#C1C1C1" stopOpacity="0.216" />
          <stop offset="1" stopColor="#D1D1D1" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_137_507"
          x1="15.0003"
          y1="20.3906"
          x2="15.0003"
          y2="53.3213"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#69101B" />
          <stop offset="0.427" stopColor="#400A10" />
        </linearGradient>
        <radialGradient
          id="paint6_radial_137_507"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(20.625 10.3125) scale(4.21875)"
        >
          <stop stopColor="white" />
          <stop offset="0.505" stopColor="white" />
          <stop offset="0.588" stopColor="white" />
          <stop offset="0.804" stopColor="#FDFEFF" />
          <stop offset="0.886" stopColor="#F6FAFF" />
          <stop offset="0.945" stopColor="#EAF3FF" />
          <stop offset="0.993" stopColor="#D9EAFF" />
          <stop offset="1" stopColor="#D6E8FF" />
        </radialGradient>
        <radialGradient
          id="paint7_radial_137_507"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(22.6924 10.3922) scale(1.99219)"
        >
          <stop offset="0.005" stopColor="#414D4D" />
          <stop offset="0.206" stopColor="#3A4545" />
          <stop offset="0.522" stopColor="#272E2E" />
          <stop offset="0.914" stopColor="#080909" />
          <stop offset="1" />
        </radialGradient>
        <radialGradient
          id="paint8_radial_137_507"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(9.375 10.3125) scale(4.21875)"
        >
          <stop stopColor="white" />
          <stop offset="0.505" stopColor="white" />
          <stop offset="0.588" stopColor="white" />
          <stop offset="0.804" stopColor="#FDFEFF" />
          <stop offset="0.886" stopColor="#F6FAFF" />
          <stop offset="0.945" stopColor="#EAF3FF" />
          <stop offset="0.993" stopColor="#D9EAFF" />
          <stop offset="1" stopColor="#D6E8FF" />
        </radialGradient>
        <radialGradient
          id="paint9_radial_137_507"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(7.39209 10.3922) scale(1.99219)"
        >
          <stop offset="0.005" stopColor="#414D4D" />
          <stop offset="0.206" stopColor="#3A4545" />
          <stop offset="0.522" stopColor="#272E2E" />
          <stop offset="0.914" stopColor="#080909" />
          <stop offset="1" />
        </radialGradient>
        <linearGradient
          id="paint10_linear_137_507"
          x1="15"
          y1="15"
          x2="11"
          y2="15"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFA3" />
          <stop offset="1" stopColor="#00FFA3" stopOpacity="0" />
        </linearGradient>
        <clipPath id="clip0_137_507">
          <rect width="30" height="30" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const WaterFallEmoji = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_137_507)">
        <path
          d="M15.0001 29.5312C2.01577 29.5312 0.451086 18.2812 0.468899 15.4688V14.5312C0.451086 11.7188 2.01577 0.46875 15.0001 0.46875C27.9845 0.46875 29.5492 11.7188 29.5314 14.5312V15.4688C29.5492 18.2812 27.9845 29.5312 15.0001 29.5312Z"
          fill="url(#paint0_linear_137_507)"
        />
        <path
          d="M22.9688 19.6875C22.9688 18.9416 22.6724 18.2262 22.145 17.6988C21.6175 17.1713 20.9022 16.875 20.1562 16.875H9.84375C9.09783 16.875 8.38246 17.1713 7.85501 17.6988C7.32757 18.2262 7.03125 18.9416 7.03125 19.6875C7.03125 19.7667 7.03687 19.8445 7.04297 19.9219C7.03598 19.9998 7.03207 20.078 7.03125 20.1562C7.03125 20.9022 7.32757 21.6175 7.85501 22.145C8.38246 22.6724 9.09783 22.9688 9.84375 22.9688H20.1562C20.9022 22.9688 21.6175 22.6724 22.145 22.145C22.6724 21.6175 22.9688 20.9022 22.9688 20.1562C22.9679 20.078 22.964 19.9998 22.957 19.9219C22.964 19.8439 22.9679 19.7657 22.9688 19.6875Z"
          fill="#F9BF06"
        />
        <path
          d="M22.9688 19.2188C22.9688 18.4728 22.6724 17.7575 22.145 17.23C21.6175 16.7026 20.9022 16.4063 20.1562 16.4062H9.84375C9.09783 16.4063 8.38246 16.7026 7.85501 17.23C7.32757 17.7575 7.03125 18.4728 7.03125 19.2188C7.03125 19.298 7.03687 19.3758 7.04297 19.4531C7.03598 19.5311 7.03207 19.6093 7.03125 19.6875C7.03125 20.4334 7.32757 21.1488 7.85501 21.6762C8.38246 22.2037 9.09783 22.5 9.84375 22.5H20.1562C20.9022 22.5 21.6175 22.2037 22.145 21.6762C22.6724 21.1488 22.9688 20.4334 22.9688 19.6875C22.9679 19.6093 22.964 19.5311 22.957 19.4531C22.964 19.3752 22.9679 19.297 22.9688 19.2188Z"
          fill="#ED8D06"
        />
        <path
          d="M9.84375 22.5H20.1562C20.9022 22.5 21.6175 22.2037 22.145 21.6762C22.6724 21.1488 22.9688 20.4334 22.9688 19.6875H7.03125C7.03125 20.4334 7.32757 21.1488 7.85501 21.6762C8.38246 22.2037 9.09783 22.5 9.84375 22.5Z"
          fill="url(#paint1_linear_137_507)"
        />
        <path
          d="M20.1562 16.875H9.84375C9.09783 16.875 8.38246 17.1713 7.85501 17.6988C7.32757 18.2262 7.03125 18.9416 7.03125 19.6875H22.9688C22.9688 18.9416 22.6724 18.2262 22.145 17.6988C21.6175 17.1713 20.9022 16.875 20.1562 16.875Z"
          fill="url(#paint2_linear_137_507)"
        />
        <path
          d="M20.1562 16.875H9.84375C9.09783 16.875 8.38246 17.1713 7.85501 17.6988C7.32757 18.2262 7.03125 18.9416 7.03125 19.6875C7.03125 20.4334 7.32757 21.1488 7.85501 21.6762C8.38246 22.2037 9.09783 22.5 9.84375 22.5H20.1562C20.9022 22.5 21.6175 22.2037 22.145 21.6762C22.6724 21.1488 22.9688 20.4334 22.9688 19.6875C22.9688 18.9416 22.6724 18.2262 22.145 17.6988C21.6175 17.1713 20.9022 16.875 20.1562 16.875Z"
          fill="url(#paint3_linear_137_507)"
        />
        <path
          d="M20.1562 16.875H9.84375C9.09783 16.875 8.38246 17.1713 7.85501 17.6988C7.32757 18.2262 7.03125 18.9416 7.03125 19.6875H22.9688C22.9688 18.9416 22.6724 18.2262 22.145 17.6988C21.6175 17.1713 20.9022 16.875 20.1562 16.875Z"
          fill="url(#paint4_linear_137_507)"
        />
        <path
          d="M21.71 17.3438H21.7034C21.2453 17.0384 20.7071 16.8753 20.1565 16.875H9.84402C9.29346 16.8753 8.75529 17.0384 8.29715 17.3438H8.29152C7.78819 17.6776 7.40571 18.1647 7.20068 18.7328C6.99566 19.301 6.97898 19.92 7.15312 20.4984C7.32725 21.0767 7.68295 21.5837 8.16758 21.9441C8.65221 22.3046 9.24002 22.4995 9.84402 22.5H10.3128C9.60776 22.4995 8.92864 22.2343 8.40993 21.7568C7.89121 21.2793 7.57074 20.6244 7.51199 19.9219H22.4886C22.4298 20.6244 22.1093 21.2793 21.5906 21.7568C21.0719 22.2343 20.3928 22.4995 19.6878 22.5H20.1565C20.7606 22.4997 21.3486 22.305 21.8333 21.9446C22.3181 21.5841 22.674 21.0772 22.8482 20.4988C23.0225 19.9204 23.0059 19.3013 22.8009 18.733C22.5959 18.1648 22.2134 17.6777 21.71 17.3438ZM7.50027 19.6875C7.50027 18.3933 8.68527 17.3438 10.1473 17.3438H19.8532C21.3153 17.3438 22.5003 18.3933 22.5003 19.6875H7.50027Z"
          fill="url(#paint5_linear_137_507)"
        />
        <path
          d="M24.8438 10.3125C24.8438 9.19362 24.3993 8.12056 23.6081 7.32939C22.8169 6.53822 21.7439 6.09375 20.625 6.09375C19.5061 6.09375 18.4331 6.53822 17.6419 7.32939C16.8507 8.12056 16.4063 9.19362 16.4062 10.3125C16.4062 10.3917 16.4138 10.4686 16.418 10.5469C16.4138 10.6252 16.4062 10.702 16.4062 10.7812C16.4063 11.9001 16.8507 12.9732 17.6419 13.7644C18.4331 14.5555 19.5061 15 20.625 15C21.7439 15 22.8169 14.5555 23.6081 13.7644C24.3993 12.9732 24.8438 11.9001 24.8438 10.7812C24.8438 10.702 24.8362 10.6252 24.832 10.5469C24.8362 10.4686 24.8438 10.3917 24.8438 10.3125Z"
          fill="#FAA15D"
        />
        <path
          d="M9.375 6.09375C8.25612 6.09375 7.18306 6.53822 6.39189 7.32939C5.60072 8.12056 5.15625 9.19362 5.15625 10.3125C5.15625 10.3917 5.16375 10.4686 5.16797 10.5469C5.16375 10.6252 5.15625 10.702 5.15625 10.7812C5.15625 11.9001 5.60072 12.9732 6.39189 13.7644C7.18306 14.5555 8.25612 15 9.375 15C10.4939 15 11.5669 14.5555 12.3581 13.7644C13.1493 12.9732 13.5938 11.9001 13.5938 10.7812C13.5938 10.702 13.5863 10.6252 13.582 10.5469C13.5863 10.4686 13.5938 10.3917 13.5938 10.3125C13.5938 9.19362 13.1493 8.12056 12.3581 7.32939C11.5669 6.53822 10.4939 6.09375 9.375 6.09375Z"
          fill="#FAA44E"
        />
        <path
          d="M24.8438 9.84375C24.8438 8.72487 24.3993 7.65181 23.6081 6.86064C22.8169 6.06947 21.7439 5.625 20.625 5.625C19.5061 5.625 18.4331 6.06947 17.6419 6.86064C16.8507 7.65181 16.4062 8.72487 16.4062 9.84375C16.4062 9.92297 16.4138 9.99984 16.418 10.0781C16.4138 10.1564 16.4062 10.2333 16.4062 10.3125C16.4062 11.4314 16.8507 12.5044 17.6419 13.2956C18.4331 14.0868 19.5061 14.5312 20.625 14.5312C21.7439 14.5312 22.8169 14.0868 23.6081 13.2956C24.3993 12.5044 24.8438 11.4314 24.8438 10.3125C24.8438 10.2333 24.8362 10.1564 24.832 10.0781C24.8362 9.99984 24.8438 9.92297 24.8438 9.84375ZM9.375 5.625C8.25612 5.625 7.18306 6.06947 6.39189 6.86064C5.60072 7.65181 5.15625 8.72487 5.15625 9.84375C5.15625 9.92297 5.16375 9.99984 5.16797 10.0781C5.16375 10.1564 5.15625 10.2333 5.15625 10.3125C5.15625 11.4314 5.60072 12.5044 6.39189 13.2956C7.18306 14.0868 8.25612 14.5312 9.375 14.5312C10.4939 14.5312 11.5669 14.0868 12.3581 13.2956C13.1493 12.5044 13.5938 11.4314 13.5938 10.3125C13.5938 10.2333 13.5863 10.1564 13.582 10.0781C13.5863 9.99984 13.5938 9.92297 13.5938 9.84375C13.5938 8.72487 13.1493 7.65181 12.3581 6.86064C11.5669 6.06947 10.4939 5.625 9.375 5.625Z"
          fill="#ED8D06"
        />
        <path
          d="M20.625 14.5312C22.955 14.5312 24.8438 12.6425 24.8438 10.3125C24.8438 7.98255 22.955 6.09375 20.625 6.09375C18.295 6.09375 16.4062 7.98255 16.4062 10.3125C16.4062 12.6425 18.295 14.5312 20.625 14.5312Z"
          fill="url(#paint6_radial_137_507)"
        />
        <path
          d="M22.6924 12.3844C23.7926 12.3844 24.6846 11.4925 24.6846 10.3922C24.6846 9.29196 23.7926 8.40002 22.6924 8.40002C21.5921 8.40002 20.7002 9.29196 20.7002 10.3922C20.7002 11.4925 21.5921 12.3844 22.6924 12.3844Z"
          fill="url(#paint7_radial_137_507)"
        />
        <path
          d="M9.375 14.5312C11.705 14.5312 13.5938 12.6425 13.5938 10.3125C13.5938 7.98255 11.705 6.09375 9.375 6.09375C7.04505 6.09375 5.15625 7.98255 5.15625 10.3125C5.15625 12.6425 7.04505 14.5312 9.375 14.5312Z"
          fill="url(#paint8_radial_137_507)"
        />
        <path
          d="M7.39209 12.3844C8.49234 12.3844 9.38428 11.4925 9.38428 10.3922C9.38428 9.29196 8.49234 8.40002 7.39209 8.40002C6.29184 8.40002 5.3999 9.29196 5.3999 10.3922C5.3999 11.4925 6.29184 12.3844 7.39209 12.3844Z"
          fill="url(#paint9_radial_137_507)"
        />
      </g>
      <path d="M15 0.5L15 29.5" stroke="#00FFA3" strokeLinecap="round" />
      <path
        d="M15 0.500013L15 29.5C15 29.5 13.6253 29.6486 11 29.1237L11 0.873911C13.7166 0.339999 15 0.500013 15 0.500013Z"
        fill="url(#paint10_linear_137_507)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_137_507"
          x1="15.0001"
          y1="0.61125"
          x2="15.0001"
          y2="29.6737"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE100" />
          <stop offset="1" stopColor="#F98900" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_137_507"
          x1="7.03125"
          y1="21.0937"
          x2="22.9688"
          y2="21.0937"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B8B4B2" />
          <stop offset="0.143" stopColor="#D0CCC9" />
          <stop offset="0.374" stopColor="#F2EDEA" />
          <stop offset="0.5" stopColor="#FFFAF6" />
          <stop offset="0.638" stopColor="#F9F5F1" />
          <stop offset="0.825" stopColor="#E8E5E3" />
          <stop offset="1" stopColor="#D1D1D1" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_137_507"
          x1="7.03125"
          y1="21.0937"
          x2="22.9688"
          y2="21.0937"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B8B4B2" />
          <stop offset="0.143" stopColor="#D0CCC9" />
          <stop offset="0.374" stopColor="#F2EDEA" />
          <stop offset="0.5" stopColor="#FFFAF6" />
          <stop offset="0.638" stopColor="#F9F5F1" />
          <stop offset="0.825" stopColor="#E8E5E3" />
          <stop offset="1" stopColor="#D1D1D1" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_137_507"
          x1="15"
          y1="22.4766"
          x2="15"
          y2="16.8862"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D1D1D1" stopOpacity="0" />
          <stop offset="0.05" stopColor="#CECECE" stopOpacity="0.041" />
          <stop offset="0.322" stopColor="#C1C1C1" stopOpacity="0.24" />
          <stop offset="0.579" stopColor="#B8B8B8" stopOpacity="0.383" />
          <stop offset="0.812" stopColor="#B2B2B2" stopOpacity="0.47" />
          <stop offset="1" stopColor="#B0B0B0" stopOpacity="0.5" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_137_507"
          x1="15"
          y1="17.168"
          x2="15"
          y2="19.912"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ABABAB" stopOpacity="0.5" />
          <stop offset="0.541" stopColor="#C1C1C1" stopOpacity="0.216" />
          <stop offset="1" stopColor="#D1D1D1" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_137_507"
          x1="15.0003"
          y1="20.3906"
          x2="15.0003"
          y2="53.3213"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#69101B" />
          <stop offset="0.427" stopColor="#400A10" />
        </linearGradient>
        <radialGradient
          id="paint6_radial_137_507"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(20.625 10.3125) scale(4.21875)"
        >
          <stop stopColor="white" />
          <stop offset="0.505" stopColor="white" />
          <stop offset="0.588" stopColor="white" />
          <stop offset="0.804" stopColor="#FDFEFF" />
          <stop offset="0.886" stopColor="#F6FAFF" />
          <stop offset="0.945" stopColor="#EAF3FF" />
          <stop offset="0.993" stopColor="#D9EAFF" />
          <stop offset="1" stopColor="#D6E8FF" />
        </radialGradient>
        <radialGradient
          id="paint7_radial_137_507"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(22.6924 10.3922) scale(1.99219)"
        >
          <stop offset="0.005" stopColor="#414D4D" />
          <stop offset="0.206" stopColor="#3A4545" />
          <stop offset="0.522" stopColor="#272E2E" />
          <stop offset="0.914" stopColor="#080909" />
          <stop offset="1" />
        </radialGradient>
        <radialGradient
          id="paint8_radial_137_507"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(9.375 10.3125) scale(4.21875)"
        >
          <stop stopColor="white" />
          <stop offset="0.505" stopColor="white" />
          <stop offset="0.588" stopColor="white" />
          <stop offset="0.804" stopColor="#FDFEFF" />
          <stop offset="0.886" stopColor="#F6FAFF" />
          <stop offset="0.945" stopColor="#EAF3FF" />
          <stop offset="0.993" stopColor="#D9EAFF" />
          <stop offset="1" stopColor="#D6E8FF" />
        </radialGradient>
        <radialGradient
          id="paint9_radial_137_507"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(7.39209 10.3922) scale(1.99219)"
        >
          <stop offset="0.005" stopColor="#414D4D" />
          <stop offset="0.206" stopColor="#3A4545" />
          <stop offset="0.522" stopColor="#272E2E" />
          <stop offset="0.914" stopColor="#080909" />
          <stop offset="1" />
        </radialGradient>
        <linearGradient
          id="paint10_linear_137_507"
          x1="15"
          y1="15"
          x2="11"
          y2="15"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFA3" />
          <stop offset="1" stopColor="#00FFA3" stopOpacity="0" />
        </linearGradient>
        <clipPath id="clip0_137_507">
          <rect width="30" height="30" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
